import {Typography} from '@mui/material';
import {LightIconPicker} from '@wallaby-ui/core';
import {LightSelectFilter} from '@wallaby-ui/document';
import React from 'react';

import {ShortcutData} from '../DrpCombinationManagementDialog';

type Props = {
  editingShortcuts: ShortcutData[];
  availableIcons: string[];
  instanceOptions: Array<{id: string; label: string}>;
  onUpdateShortcut: (index: number, field: keyof ShortcutData, value: any) => void;
  isSubmitting: boolean;
  error?: string;
};

export const ShortcutsEditor: React.FC<Props> = ({
  editingShortcuts,
  availableIcons,
  instanceOptions,
  onUpdateShortcut,
  isSubmitting,
  error,
}) => {
  return (
    <>
      {editingShortcuts.map((shortcut, index) => (
        <div
          key={index}
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 12,
            padding: 8,
            backgroundColor: 'var(--dlThemeGray-50)',
            borderRadius: 8,
          }}
        >
          <Typography variant='labelBold'>{index + 1}.</Typography>

          <LightIconPicker
            iconNames={availableIcons}
            selectedIconName={shortcut.iconName}
            onIconSelected={(name) => onUpdateShortcut(index, 'iconName', name)}
            showEmptyOption={false}
            iconColorStyle={'var(--dlLightIconButtonFill)'}
          />

          <LightSelectFilter
            style={{flex: 1}}
            config={{
              name: `shortcut-combination-${index}`,
              ui: {label: 'hospitalization.detail.phRec.combination.shortcuts.combination'},
            }}
            options={instanceOptions}
            value={shortcut.combinationInstanceId ? String(shortcut.combinationInstanceId) : null}
            onChange={(value) => onUpdateShortcut(index, 'combinationInstanceId', value ? Number(value) : 0)}
            disabled={isSubmitting}
            isClearable={false}
          />
        </div>
      ))}

      {error && (
        <Typography variant='value' style={{color: 'var(--dlThemeError)', fontSize: 12}}>
          {error}
        </Typography>
      )}
    </>
  );
};
